var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartMedicineCard_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import moment from 'moment';
import React, { Component } from 'react';
import MyChartMedicineCardAPI from './my-chart-medicine-card-api';
import { Card, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import './my-chart-medicine-card.css';
var ViewedClass;
(function (ViewedClass) {
    ViewedClass["READ"] = "S";
    ViewedClass["NOT_READ"] = "N";
})(ViewedClass || (ViewedClass = {}));
let MyChartMedicineCard = class MyChartMedicineCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClickMedicine = () => {
            const { onClick, read, medicament, dose, startDate, sequence, endDate } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dose,
                        endDate,
                        medicament,
                        read,
                        sequence,
                        startDate
                    }
                }));
            }
        };
    }
    static { MyChartMedicineCard_1 = this; }
    static { this.propTypes = { className: string, onClick: eventListener, uuid: string, width: number }; }
    static { this.defaultProps = { width: 12 }; }
    render() {
        const { uuid, width = MyChartMedicineCard_1.defaultProps.width, className, medicament, startDate, endDate, dose, read, situation } = this.props;
        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const situationDescription = MessageService.translate(situation);
        const startDateFormat = startDate ? moment(startDate).locale(localeStr).format('L') : '-';
        const endDateFormat = endDate ? moment(endDate).locale(localeStr).format('L') : '-';
        const notViewedClass = read === ViewedClass.NOT_READ ? 'not-viewed' : '';
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: `${className} ${notViewedClass}`, onClick: () => this.handleClickMedicine() },
            React.createElement("div", { className: 'medicine' },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.label.medicine')}` })),
                        React.createElement("span", { className: "emphasis-info" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: medicament, className: "subtitle" })))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.label.dose')}` })),
                        React.createElement("span", { className: "emphasis-info" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: dose, className: "subtitle" })))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.label.status')}` })),
                        React.createElement("span", { className: "emphasis-info" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: situationDescription, className: "subtitle" })))),
                React.createElement("div", { className: "detail-area-date" },
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.start-date')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: startDateFormat, className: "subtitle" })))),
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.end-date')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: endDateFormat, className: "subtitle" }))))))));
    }
};
MyChartMedicineCard = MyChartMedicineCard_1 = __decorate([
    AwesomeComponent({ api: MyChartMedicineCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartMedicineCard);
export default MyChartMedicineCard;
//# sourceMappingURL=my-chart-medicine-card.js.map